import { Box, Button } from "@mui/material";
import { useReminderTypesQuery } from "web_myplann/Api/Reminders/useReminderTypesQuery";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ReminderFormFields } from "web_myplann/Reminders/Components/ReminderFormFields";
import { useReminderEditForm } from "web_myplann/Reminders/Hooks/useReminderEditForm";
import type {
	Reminder,
	ReminderEntity,
} from "web_myplann/Reminders/Types/ReminderTypes";
import { SmallDrawer } from "web_myplann/Shared/Components/SmallDrawer";

type Props = {
	entity: ReminderEntity;
	reminder: Reminder;
	open: boolean;
	onClose: () => void;
};

export const ReminderEditDrawer = ({
	entity,
	reminder,
	open,
	onClose,
}: Props) => {
	const { t } = useResource();

	const { data: templates = [] } = useReminderTypesQuery(entity);

	const { form, submit, isSubmitting } = useReminderEditForm({
		reminder,
		onSuccess: onClose,
	});

	return (
		<SmallDrawer
			open={open}
			onClose={onClose}
			title={t(Resources.Reminders.Form.editTitle)}
		>
			<ReminderFormFields form={form} templates={templates} />

			<Box px={1.6} py={1.6}>
				<Button
					variant="primary"
					onClick={submit}
					disabled={!form.formState.isValid}
					loading={isSubmitting}
				>
					{t(Resources.Reminders.Form.editCta)}
				</Button>
			</Box>
		</SmallDrawer>
	);
};
